export default __webpack_public_path__ + "static/media/1033.0f3afb81.png";